// hooks/useCardPreview.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const DEFAULT_DATA = {
    CardBg: 'https://lol-image-bucket.s3.amazonaws.com/images/CardBg/UserCardBg-a79c55e6-9126-495c-a11f-f15bc631916f.jpg',
};

const preloadImage = (url) => {
    return new Promise((resolve) => {  // ← reject હટાવ્યો, always resolve
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => resolve(url);  // ← error પણ resolve કરો
        img.src = url;
    });
};

const useCardPreview = ({ type, category, shouldShowModal }) => {
    const [loading, setLoading] = useState(!shouldShowModal);
    const [randomData, setRandomData] = useState(shouldShowModal ? DEFAULT_DATA : null);
    const [imageLoaded, setImageLoaded] = useState(shouldShowModal);
    const [noInternet, setNoInternet] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (shouldShowModal || randomData) return;

        if (!navigator.onLine) {
            setNoInternet(true);
            return;
        }

        setLoading(true);
        setImageLoaded(false);

        const startTime = Date.now();
        const body = { type, ...(category && { category }) };

        axios.post(`https://api.lolcards.link/api/web/common/cardpreview`, body)
            .then(({ data }) => {
                const fetchedData = data.data;
                setRandomData(fetchedData);
                setError(false);
                return preloadImage(fetchedData.CardBg);
            })
            .then(() => {
                const remaining = Math.max(0, 1000 - (Date.now() - startTime));
                setTimeout(() => {
                    setImageLoaded(true);
                    setLoading(false);
                }, remaining);
            })
            .catch(() => {
                // API fail - show error screen
                setError(true);
                setRandomData(DEFAULT_DATA);
                const remaining = Math.max(0, 1000 - (Date.now() - startTime));
                setTimeout(() => {
                    setImageLoaded(true);
                    setLoading(false);
                }, remaining);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { loading, randomData, imageLoaded, noInternet, error };
};

export default useCardPreview;